import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { DealerService } from '../services/dealer.service';
import { User } from '../../shared/models/user.interface';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DealerAccountData } from '../../shared/models/dealer-account.interface';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-dealer-users',
  templateUrl: './dealer-users.component.html',
  styleUrls: ['./dealer-users.component.scss']
})

export class DealerUsersComponent implements OnInit {

  dataSource = new MatTableDataSource<User>();
  displayedColumns: string[] =
    ['lastName', 'email', 'phoneNumber', 'action'];

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  dealerUsers: User[];
  searchText: string;
  dealerName: string;
  dealerId: number;
  
  constructor(private dealerService: DealerService, public dialogRef: MatDialogRef<DealerUsersComponent>, @Inject(MAT_DIALOG_DATA) public data: DealerAccountData) { }

  ngOnInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

    this.dealerId = this.data.id;
    this.dealerService.getDealer(this.dealerId)
      .subscribe({
        next: (data) => {
          this.dealerName = data.dealer_BusinessName;
        }
      });

    this.dealerService.getUsers(this.dealerId)
      .subscribe({
        next: (data) => {
          this.dealerUsers = data;

          this.dataSource.data = this.dealerUsers;
        }
      });
  }

  searchDealerUsers() {
    this.dealerService.searchUsers(this.dealerId, this.searchText)
      .subscribe({
        next: (data) => {
          this.dealerUsers = data;

          this.dataSource.data = this.dealerUsers;
        }
      });
  }

  toggleUserStatus(userId: string) {
    this.dealerService.toggleUserStatus(userId, this.dealerId)
      .subscribe({
        next: (data) => {
          if (data) {
            this.dealerUsers.find(u => u.id == userId).isActive = data.isActive;
            let activeStatusId = "user_status_active" + userId;
            let inActiveStatusId = "user_status_inactive" + userId;

            if (data.isActive) {
              document.getElementById(activeStatusId).className = "text-success";
              document.getElementById(inActiveStatusId).className = "";
            }
            else {
              document.getElementById(activeStatusId).className = "";
              document.getElementById(inActiveStatusId).className = "text-danger";
            }
          }
        }
      });
  }
}
